import React, { useContext, useEffect, useState } from "react";
import { Form, Input, Button, Checkbox, Select } from "antd";
import { UserContext } from "../../../context/UserContext";
import MetadataEditorModal from "../MetadataEditorModal";

const CreatePlotModalContent = ({
  plotLabel,
  setOpen,
  createCallback,
  allOrgs,
  allSites,
  allCrops,
  allVarieties,
  currentOrg,
  currentSite,
  currentCrop,
}) => {
  const [form] = Form.useForm();
  const { userData } = useContext(UserContext);
  const [metadataObj, setMetadataObj] = useState({});
  const [showMetadataEditor, setShowMetadataEditor] = useState(false);

  useEffect(() => {
    form.setFieldsValue({
      organization: currentOrg,
      site: currentSite,
      crop: currentCrop,
      is_loose: false,
    });
  }, [currentOrg, currentSite, currentCrop, form]);

  const onFinish = (values) => {
    values.metadata = metadataObj || {};
    values.organization = currentOrg;
    createCallback(values);
    form.resetFields();
    setMetadataObj({});
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div className="flex justify-center">
      <Form
        id="createPlotForm"
        className="max-w-[80%]"
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <div className="flex items-center justify-between">
          {/* Site Dropdown - preselected and disabled */}
          <Form.Item
            className="pr-8"
            name="site"
            label="Site"
            rules={[
              {
                required: true,
                message: "Please select a site",
              },
            ]}
          >
            <Select
              placeholder="Select Site"
              options={allSites}
              showSearch
              disabled // Disable the site Select
              filterOption={(input, option) =>
                option.label.toLowerCase().includes(input.toLowerCase())
              }
            />
          </Form.Item>

          {/* Crop Dropdown - preselected and disabled */}
          <Form.Item
            name="crop"
            label="Crop"
            rules={[
              {
                required: true,
                message: "Please select a crop",
              },
            ]}
          >
            <Select
              placeholder="Select Crop"
              options={allCrops}
              showSearch
              disabled // Disable the crop Select
              filterOption={(input, option) =>
                option.label.toLowerCase().includes(input.toLowerCase())
              }
            />
          </Form.Item>
        </div>

        <Form.Item name="variety" label="Variety">
          <Select
            placeholder="Select Variety"
            options={allVarieties}
            showSearch
            filterOption={(input, option) =>
              option.label?.toLowerCase()?.includes(input?.toLowerCase())
            }
          />
        </Form.Item>

        {/* Plot Name */}
        <Form.Item
          name="name"
          label="Name"
          rules={[
            {
              required: true,
              message: "Name is required",
            },
          ]}
        >
          <Input placeholder={plotLabel + " Name"} />
        </Form.Item>

        <div className="flex items-center justify-between">
          {/* Active Checkbox */}
          <Form.Item
            name="is_active"
            valuePropName="checked"
            label="Active"
            initialValue={true}
          >
            <Checkbox></Checkbox>
          </Form.Item>

          {/* Is Loose Checkbox */}
          <Form.Item
            name="is_loose"
            valuePropName="checked"
            label="Loose Harvested"
            initialValue={false}
          >
            <Checkbox></Checkbox>
          </Form.Item>
        </div>
        {/* Metadata */}
        <Form.Item
          name="metadata"
          label="Metadata"
          rules={[
            {
              required: false,
              message: "Metadata is required and should be valid JSON",
            },
            // {
            //   validator: (_, value) => {
            //     try {
            //       JSON.parse(value);
            //       return Promise.resolve();
            //     } catch (err) {
            //       return Promise.reject(
            //         new Error("Metadata must be valid JSON"),
            //       );
            //     }
            //   },
            // },
          ]}
        >
          {/*<Input.TextArea placeholder='{"key": "value"}' />*/}
          <Button color="primary" onClick={() => setShowMetadataEditor(true)}>
            Edit Metadata
          </Button>
        </Form.Item>

        {/* Submit Button */}
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Create
          </Button>
        </Form.Item>
      </Form>
      <MetadataEditorModal
        name={plotLabel + " Metadata"}
        visible={showMetadataEditor}
        onClose={() => setShowMetadataEditor(false)}
        metadata={metadataObj}
        onUpdateMetadata={(updatedMetadata) => setMetadataObj(updatedMetadata)}
      />
    </div>
  );
};

export default CreatePlotModalContent;
